// Shared site content — single source of truth for nav, services, industries, people.
export const NAV = [
  { label: "Home", to: "/" },
  { label: "The Firm", to: "/the-firm" },
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/industries" },
  { label: "Our People", to: "/our-people" },
  { label: "Insights", to: "/insights" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const CONTACT = {
  firm: "Arun Gupta & Co.",
  discipline: "Chartered Accountants",
  addressLines: [
    "Office No. 20, Upper Floor, Roland Complex,",
    "37/17, The Mall,",
    "Kanpur - 208001,",
    "Uttar Pradesh, India",
  ],
  phones: ["+91 9336117987", "+91 7071907987"],
  email: "ag.arunguptaco@gmail.com",
  linkedin: "https://www.linkedin.com/company/arunguptaco/",
  maps: "https://maps.app.goo.gl/3gM6iYSTnqL5Tchp6",
  mapsEmbed:
    "https://www.google.com/maps?q=Roland+Complex+37%2F17+The+Mall+Kanpur+208001&output=embed",
};

export const CONFIDENTIALITY =
  "Please do not share confidential financial information, sensitive personal information or original documents through this form. We will discuss appropriate ways to share any information required for an engagement.";

export const CORE_SERVICES = [
  {
    id: "audit-assurance",
    index: "01",
    title: "Audit & Assurance",
    lead: "Statutory audits, tax audits and other assurance assignments, with a focus on reliable financial information, sound reporting and professional discipline.",
    points: [
      "Statutory audits",
      "Tax audits",
      "Audit of partnership firms",
      "Audit of private limited companies",
      "Financial statement and reporting support",
      "Relevant assurance assignments",
    ],
  },
  {
    id: "taxation",
    index: "02",
    title: "Taxation",
    lead: "Practical support across direct and indirect taxation, from routine compliance to assessments, notices and representation.",
    points: [
      "Income tax advisory",
      "Income tax return filing and compliance",
      "Tax planning",
      "TDS-related matters",
      "Assessments and scrutiny",
      "Notices and departmental communications",
      "Tax representation",
      "Appeals before relevant appellate authorities",
      "GST registration and compliance",
      "GST returns",
      "GST advisory",
      "ITC and reconciliation matters",
      "GST notices and proceedings",
      "GST representation and appeals where applicable",
    ],
  },
  {
    id: "accounting-reporting",
    index: "03",
    title: "Accounting & Financial Reporting",
    lead: "Professional accounting and reporting support focused on accurate books, year-end finalisation and meaningful financial information.",
    points: [
      "Finalisation of accounts",
      "Financial statement preparation",
      "Year-end accounting support",
      "Review of financial information",
      "Accounting advisory",
      "Financial reporting support",
    ],
  },
  {
    id: "business-advisory",
    index: "04",
    title: "Business Advisory & Consulting",
    lead: "Financial and business perspectives that help owners and management understand performance, evaluate decisions and plan with greater clarity.",
    points: [
      "Financial analysis",
      "Management information and decision support",
      "Business and financial advisory",
      "Accounting and finance process advisory",
      "Financial planning support",
      "Commercial and business decision support",
    ],
  },
];

export const DEVELOPING_SERVICES = [
  {
    id: "outsourced-finance",
    index: "05",
    title: "Outsourced Accounting & Finance",
    lead: "Developing capabilities around ongoing accounting oversight, finance processes, periodic financial reporting, MIS and coordination of finance requirements.",
  },
  {
    id: "strategic-finance",
    index: "06",
    title: "Strategic Finance & CFO Support",
    lead: "An evolving area focused on financial performance, planning, cash flow, management information and strategic finance support, including fractional finance leadership where appropriate.",
  },
];

export const APPROACH = [
  {
    index: "01",
    title: "Integrity",
    body: "Professional responsibility and independence form the foundation of our work.",
  },
  {
    index: "02",
    title: "Understanding",
    body: "Good advice begins with understanding the numbers, the business and the circumstances behind them.",
  },
  {
    index: "03",
    title: "Practicality",
    body: "Technical knowledge matters most when it can be translated into clear, useful action.",
  },
];

export const SECTORS = [
  "Manufacturing",
  "Trading & Distribution",
  "Real Estate",
  "Logistics & Transportation",
  "Steel & Metals",
  "Industrial Products",
  "Pipe Fittings & Related Manufacturing",
  "Beverage & Regulated Businesses",
  "Other Commercial Businesses",
];

export const ORG_TYPES = [
  "Partnership Firms",
  "Private Limited Companies",
  "Owner-Managed Businesses",
  "Growing Businesses",
  "Professionals & Individuals",
];

export const PEOPLE = [
  {
    id: "arun-kumar-gupta",
    name: "CA Arun Kumar Gupta",
    role: "Founder & Partner",
    image: "/brand/arun-gupta.webp",
    objectPosition: "center 20%",
    short:
      "Founder of the firm and a Fellow Member of the Institute of Chartered Accountants of India, with a professional practice spanning audit, taxation and accounting.",
    paragraphs: [
      "CA Arun Kumar Gupta qualified as a Chartered Accountant in January 1990 and commenced professional practice shortly thereafter. In February 1990, he established Arun Gupta & Co., laying the foundation for a professional practice that has continued to evolve over the decades.",
      "His professional practice spans audit, taxation, accounting and related financial matters, with experience developed through long-standing relationships with businesses and individuals across diverse sectors.",
      "He is a Fellow Member of the Institute of Chartered Accountants of India and has been actively associated with professional forums in Kanpur. His professional engagements have included leadership roles with the Kanpur Income Tax Bar Association and the Kanpur GST (CA) Association, including serving as President of the latter during 2025–26.",
      "He has also participated in professional sessions on taxation and GST-related developments.",
    ],
  },
  {
    id: "ankur-gupta",
    name: "CA Ankur Gupta",
    role: "Partner",
    image: "/brand/ankur-new.png",
    objectPosition: "center 12%",
    short:
      "Brings a broader financial reporting and international finance perspective to the firm, with prior experience in an international investment banking environment.",
    paragraphs: [
      "CA Ankur Gupta brings a broader financial reporting and international finance perspective to Arun Gupta & Co.",
      "Prior to joining the firm's practice, he gained professional experience in an international investment banking environment, including work within the Legal Entity Controllers function at Goldman Sachs.",
      "His experience has provided exposure to financial reporting, legal entity accounting, regulatory and tax considerations, financial controls and international accounting frameworks including IFRS and US GAAP. His work involved supporting Goldman Sachs entities and revenue-generating branches across the EMEA region, from accounting and financial reporting through audit and coordination with multiple tax, regulatory and business stakeholders.",
      "At Arun Gupta & Co., Ankur is focused on contributing to the firm's evolving direction — building on its established professional foundation while expanding capabilities across financial reporting, business advisory, outsourced finance and strategic finance support.",
    ],
  },
];

export const CAREER_CATEGORIES = [
  {
    title: "Article Assistants",
    body: "Structured articleship with exposure to real client requirements across audit, taxation and accounting.",
  },
  {
    title: "Qualified Chartered Accountants",
    body: "Meaningful professional responsibility across assurance, taxation and advisory engagements.",
  },
  {
    title: "Accounting & Tax Professionals",
    body: "Hands-on work in accounting, finalisation, compliance and departmental matters.",
  },
  {
    title: "Finance & Advisory Professionals",
    body: "A role in the firm's evolving finance, reporting and advisory capabilities.",
  },
];

export const INSIGHT_CATEGORIES = [
  {
    title: "Tax & Regulatory",
    body: "Perspectives on direct and indirect taxation, compliance and regulatory developments relevant to businesses and individuals.",
  },
  {
    title: "Accounting & Financial Reporting",
    body: "Notes on finalisation, financial statements and the practicalities of meaningful financial information.",
  },
  {
    title: "Business & Finance",
    body: "Commentary connecting the numbers to the decisions that owners and management actually face.",
  },
  {
    title: "Advisory Perspectives",
    body: "Reflections on the firm's evolving work across outsourced finance and strategic finance support.",
  },
];
